/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Aggregated usage summary for a role
 */
export type RoleSummary = {
  /**
   * Average cost per user (total_cost / user_count)
   */
  costPerUser: number;
  /**
   * Role identifier extracted from role URN
   */
  roleId: string;
  /**
   * Human-readable role name
   */
  roleName: string;
  /**
   * Total chat sessions across all users
   */
  totalChats: number;
  /**
   * Total cost across all users with this role
   */
  totalCost: number;
  /**
   * Sum of input tokens across all users
   */
  totalInputTokens: number;
  /**
   * Sum of output tokens across all users
   */
  totalOutputTokens: number;
  /**
   * Sum of all tokens across all users
   */
  totalTokens: number;
  /**
   * Number of users with this role
   */
  userCount: number;
};

/** @internal */
export const RoleSummary$inboundSchema: z.ZodMiniType<RoleSummary, unknown> = z
  .pipe(
    z.object({
      cost_per_user: z.number(),
      role_id: z.string(),
      role_name: z.string(),
      total_chats: z.int(),
      total_cost: z.number(),
      total_input_tokens: z.int(),
      total_output_tokens: z.int(),
      total_tokens: z.int(),
      user_count: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "cost_per_user": "costPerUser",
        "role_id": "roleId",
        "role_name": "roleName",
        "total_chats": "totalChats",
        "total_cost": "totalCost",
        "total_input_tokens": "totalInputTokens",
        "total_output_tokens": "totalOutputTokens",
        "total_tokens": "totalTokens",
        "user_count": "userCount",
      });
    }),
  );

export function roleSummaryFromJSON(
  jsonString: string,
): SafeParseResult<RoleSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RoleSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RoleSummary' from JSON`,
  );
}
